<div class="CSVPhoneReview rev">
  <!-- Segmented pill tabs -->
  <div class="rev__tabs">
    <customizable-tabs #views [tabs]="tabs" [stretch]="true" [activeTab]="activeIndex" panelId="rev-view-panel" (tabChange)="onTabChange($event)" />
  </div>

  <div id="rev-view-panel" class="views rev__view" role="tabpanel" tabindex="0" [attr.aria-labelledby]="views.activeTabId">
    @switch (currentView) {
      @case ('duplicated') { <csv-phone-duplicates /> }
      @case ('removed')    { <csv-phone-removed /> }
      @case ('updated')    { <csv-phone-updated /> }
      @case ('invalids')   { <csv-phone-invalids /> }
      @default             { <csv-phone-overview (showTab)="openTab($event)" /> }
    }
  </div>
</div>
